import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import type { TiposSeleccionFiltroStock } from "./FiltroArticulos";
import { Loading, QueryError } from "../../../components/Loading/Loading";

interface IndicadoresCantidadesProps { readonly familia: string[]; readonly subfamilia: string[]; readonly setFiltroStock: (value: TiposSeleccionFiltroStock) => void; }
export function IndicadoresCantidades(props: IndicadoresCantidadesProps) {
	const { data, error, isPending } = UseCantidadesStock({
		"idsFamilia": props.familia,
		"idsSubFamilia": props.subfamilia,
	});
	if (error) return <QueryError error={error} fallback="Error al cargar los indicadores" />;
	if (isPending) return <Loading />;

	const clickMinimo = () => props.setFiltroStock("minimo");
	const clickMaximo = () => props.setFiltroStock("maximo");
	const clickRoturaStock = () => props.setFiltroStock("roturaStock");
	const clickOFs = () => document.querySelector("#datatableOrdenes")?.scrollIntoView({ behavior: "smooth" });

	return (
		<div className="contenedorIndicadores">
			<div onClick={clickMinimo} className="piher-bg clicable">
				<h2>Bajo mínimo</h2>
				<h1>{data.minimo}</h1>
				<img src="/img/icons/arrowrightGrey.svg" className="arrow-icon" alt="Ver más" />
			</div>
			<div onClick={clickMaximo} className="piher-bg clicable">
				<h2>Sobre máximo</h2>
				<h1>{data.maximo}</h1>
				<img src="/img/icons/arrowrightGrey.svg" className="arrow-icon" alt="Ver más" />
			</div>
			<div onClick={clickRoturaStock} className="piher-bg clicable">
				<h2>Rotura de stock</h2>
				<h1>{data.roturaStock}</h1>
				<img src="/img/icons/arrowrightGrey.svg" className="arrow-icon" alt="Ver más" />
			</div>
			<div onClick={clickOFs} className="piher-bg clicable">
				<h2>Órdenes de fabricación</h2>
				<h1>{data.ofCount}</h1>
				<img src="/img/icons/arrowrightGrey.svg" className="arrow-icon" alt="Ver más" />
			</div>
		</div>
	);
}


function UseCantidadesStock(parametros: { idsFamilia: string[]; idsSubFamilia: string[]; }) {
	return useQuery<CantidadesStock>({
		queryKey: ["getArticulosStockCounts", parametros],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<CantidadesStock>("GET", "/getArticulosStockCounts", parametros);
		}
	});
}
export interface CantidadesStock {
	minimo: string,
	maximo: string,
	roturaStock: string,
	ofCount: string,
}
